import React, { useState } from 'react';
import '../about/about.style.scss'
import Footer from '../../components/footer/footer.comp';
import Navbar from '../../components/navbar/navbar.comp';
import { addCareerInterestEmailToFirestore } from '../../utils/firebase/firebase.utils'
import Button from '../../components/button/button.comp';

const Careers = () => {

    // State to hold the form values
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        education: '',
        workExperience: '',
        location: '',
        link: ''
    });


    // Function to handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

    };

    // Handle form submission
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    const [response, setResponse] = useState(false)
    const [popUp, setPopUp] = useState(false)
    const handleSubmit = async (e) => {
        e.preventDefault();
        setPopUp(true)
        try {
            await addCareerInterestEmailToFirestore(formData);  // Use the utility function
            // Clear the form
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });

            setLoadedBoolean(true)
            setResponse(true)
        } catch (error) {
            console.error("Failed to send email:", error);
            setLoadedBoolean(false)
        }
    };
    const handleClosePopUp = () => {
        console.log('close')
        setPopUp(false)
        setResponse(false)
        setLoadedBoolean(false)
    }

    return (
        <div>
            {/* Navbar */}
            < div className='section' >
                <Navbar />
            </div >

            {/* Main Section */}
            <div className='section text-section frame about'
                style={{ color: 'var(--fontlightblack1)', textAlign: 'left' }}
            >
                <h1 style={{ textAlign: 'left', color: 'var(--fontlightblack1)' }}>Career Opportunities</h1>
                <p>Reach is in the early stages of the start-up process. If you’d like to help us grow while gaining valuable experience working at a growing start-up, check out potential opportunities below.</p>

                <h3 style={{ color: 'var(--fontlightblack1)' }}>Possible Internships</h3>
                <ul>
                    <li><strong>Back End Development:</strong> Help us build and maintain the back end infrastructure using SQL databases and cloud services.</li>
                    <li><strong>Front End Development:</strong> Work on improving our React front end, focusing on user experience and responsive design.</li>
                    <li><strong>React Native Development:</strong> Help us build and refine the mobile app for both iOS and Android platforms.</li>
                    <li><strong>iOS & Android Development:</strong> Join us in developing and perfecting native apps for iOS and Android users.</li>
                    <li><strong>Social Media Marketing:</strong> Collaborate with us to grow our audience and understand our customers through targeted social media campaigns.</li>
                </ul>

                <h3 style={{ color: 'var(--fontlightblack1)' }}>What You'll Gain</h3>
                <ul>
                    <li><strong>Skilled Practice:</strong> Gain hands-on experience in the development of a real-world product.</li>
                    <li><strong>Customer Development:</strong> Learn about customer validation and lifecycle in an entrepreneurial setting.</li>
                    <li><strong>Resume Building:</strong> Enhance your resume with tangible achievements and new skills.</li>
                    <li><strong>Letter of Recommendation:</strong> Earn a letter of recommendation based on your contributions to the project.</li>
                </ul>
            </div>

            {/* Contact Form & Submit Button */}
            <div className='contact' style={{ color: 'var(--fontlightblack1)' }}>
                <h3 style={{ color: 'var(--fontlightblack1)', textAlign: 'left' }}>Interested?</h3>
                <p style={{ textAlign: 'left' }}>Awesome. We'd love to hear from you!</p>

                {/* Contact Form */}
                <form className="contact-form" onSubmit={handleSubmit}>
                    <label htmlFor="name">Your Name:</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="email">Your Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="subject">Section:</label>
                    <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select a section</option>
                        <option value="backend-developer">Back-End Developer</option>
                        <option value="frontend-developer">Front-End Developer</option>
                        <option value="react-native-developer">React Native Developer</option>
                        <option value="ios-developer">iOS Developer</option>
                        <option value="android-developer">Android Developer</option>
                        <option value="social-media-marketer">Social Media Marketer</option>
                    </select>

                    <label htmlFor="education">Education</label>
                    <input
                        type="text"
                        id="education"
                        name="education"
                        placeholder="Enter your education"
                        value={formData.education}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="workExperience">Work Experience</label>
                    <input
                        type="text"
                        id="workExperience"
                        name="workExperience"
                        placeholder="For example: 2 yrs React, 3 yrs React Native"
                        value={formData.workExperience}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="location">Location</label>
                    <input
                        type="text"
                        id="location"
                        name="location"
                        placeholder="Enter your location"
                        value={formData.location}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="link">Link</label>
                    <input
                        type="url"
                        id="link"
                        name="link"
                        placeholder="Link to your LinkedIn profile, website, other."
                        value={formData.link}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="message">Your Message:</label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="Optional"
                        rows="5"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                    ></textarea>

                    {/* Submit Button */}
                    {formData.name && formData.email && formData.subject && formData.message && formData.education && formData.workExperience && formData.location && formData.link ? (
                        <button type="submit" className="submit-button">Send Message</button>
                    ) : (
                        <button type="submit" className="submit-button disabled" disabled>Send Message</button>
                    )}
                    <p style={{ fontSize: 'small' }}>We aim to respond in 7 business days</p>
                </form>
            </div>

            {/* Footer Margin */}
            <div className="footer-margin">
            </div>

            {/* Footer */}
            <Footer />

            {/* Pop Up */}
            {
                popUp ? (
                    <div className="save-pop-up-container">
                        <div className="save-pop-up">
                            <div className="save-pop-up-header">
                                <div className="title">
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleClosePopUp}>
                                    </div>
                                </div>
                            </div>
                            {
                                !loadedBoolean ? (
                                    <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                        <p style={{ fontSize: 'large', textAlign: "center" }} >Sending...</p>
                                        <div className="this-week-loading-circle"></div>
                                    </div>
                                ) : (
                                    response ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                            <p style={{ fontSize: 'large', textAlign: "center" }} >Email Sent!</p>
                                            <p style={{ textAlign: "center" }} >Thank you for contacting us. We aim to respond in 7 business days.</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleClosePopUp} />
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                            <p style={{ fontSize: 'large', textAlign: "center" }} >Error</p>
                                            <p style={{ textAlign: "center" }} >There was an error, please try submitting response again.</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleClosePopUp} />
                                        </div>

                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

export default Careers;